import React, { useState } from "react";
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Tooltip,
} from "@mui/material";

import {
  Home,
  ExpandLess,
  ExpandMore,
  DirectionsBus,
  Map,
  Traffic,
  LocalShipping,
  CalendarMonth,
  Gavel,
  LocalParking,
  FactCheck,
} from "@mui/icons-material";

import { Link, useLocation } from "react-router-dom";
import LogoPortalData from "../../assets/logo_PortalData.png";

export default function Sidebar({ open }) {
  const location = useLocation();
  const drawerWidth = open ? 240 : 70;

  // State Submenu
  const [openModa, setOpenModa] = useState(false);
  const [openTerminal, setOpenTerminal] = useState(false);
  const [openLalin, setOpenLalin] = useState(false);
  const [openLogistik, setOpenLogistik] = useState(false);
  const [openMusiman, setOpenMusiman] = useState(false);
  const [openDalops, setOpenDalops] = useState(false);
  const [openParkir, setOpenParkir] = useState(false);
  const [openPengujian, setOpenPengujian] = useState(false);

  // Styling Submenu Wrapper (garis vertikal)
  const submenuWrapperSx = {
    borderLeft: "1px solid rgba(255,255,255,0.3)",
    ml: open ? 3 : 2,
    pl: open ? 1.5 : 1,
    py: 0.5,
  };

  const renderSubmenu = (items) => (
    <Box sx={submenuWrapperSx}>
      <List component="div" disablePadding>
        {items.map(([label, path]) => (
          <ListItemButton
            key={path}
            component={Link}
            to={path}
            sx={{
              color: "white",
              py: 0.6,
              borderRadius: 0.5,
              "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
            }}
          >
            <ListItemText
              primary={label}
              primaryTypographyProps={{ fontSize: 12 }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: drawerWidth,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          bgcolor: "#122D4B",
          color: "white",
          borderRight: "none",
          transition: "width 0.3s",
          overflowX: "hidden",

          // Global Sidebar Font
          fontSize: "12px",
          lineHeight: "16px",
        },
      }}
    >
      {/* LOGO */}
      <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
        <img
          src={LogoPortalData}
          alt="Portal Data"
          style={{
            width: open ? "160px" : "35px",
            transition: "0.3s",
          }}
        />
      </Box>

      {/* MENU UTAMA */}
      <List sx={{ px: 1 }}>
        {/* ========== HOME ========== */}
        <Tooltip title={!open ? "Beranda" : ""} placement="right">
          <ListItemButton
            component={Link}
            to="/beranda"
            sx={{
              borderRadius: 1,
              bgcolor:
                location.pathname === "/beranda" ? "#1F3F63" : "transparent",
              "&:hover": { bgcolor: "#1F3F63" },
              py: 0.8,
            }}
          >
            <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
              <Home fontSize="small" />
            </ListItemIcon>

            {open && (
              <ListItemText
                primary="Beranda"
                primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
              />
            )}
          </ListItemButton>
        </Tooltip>

        {/* ========== MODA TRANSPORTASI ========== */}
        <ListItemButton
          onClick={() => setOpenModa(!openModa)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <DirectionsBus fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Moda Transportasi"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openModa ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openModa} unmountOnExit>
          {renderSubmenu([
            ["MRT Jakarta", "/dataMRT"],
            ["LRT Jakarta", "/dataLRT"],
            // ["Pelanggan TransJakarta", "/dataTransjakarta"],
            ["Ringkasan Eksekutif TransJakarta", "/RingkasanEksekutifTJ"],
            ["JakLingko", "/dataJaklingko"],
            ["PLIS", "/dataPLIS"],
            ["Pengguna Kartu Layanan Gratis", "/dataKLG"],
            ["Agregat Penumpang", "/dataAgregatPenumpang"],
            ["Penumpang Angkutan Perairan", "/dataUPAP"],
            ["Angkutan Sekolah", "/dataUPAS"],
          ])}
        </Collapse>

        {/* ========== TERMINAL ========== */}
        <ListItemButton
          onClick={() => setOpenTerminal(!openTerminal)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <Map fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Terminal"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openTerminal ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openTerminal}>
          {renderSubmenu([
            ["Peta Lokasi Terminal", "/petaLokasi"],
            ["Data Penumpang Terminal", "/dataPenumpangTerminal"],
          ])}
        </Collapse>

        {/* ========== LALU LINTAS ========== */}
        <ListItemButton
          onClick={() => setOpenLalin(!openLalin)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <Traffic fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Lalu Lintas"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openLalin ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openLalin}>
          {renderSubmenu([
            ["Volume Lalu Lintas", "/volLaluLintas"],
            ["Volume Dalam Kota", "/volLalinDalamKota"],
            ["Jumlah Kendaraan Bermotor", "/jumlahKendaraanBermotor"],
          ])}
        </Collapse>

        {/* ========== LOGISTIK ========== */}
        <ListItemButton
          onClick={() => setOpenLogistik(!openLogistik)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <LocalShipping fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Logistik"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openLogistik ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openLogistik}>
          {renderSubmenu([
            ["Bongkar Muat", "/bongkarmuat"],
            ["Komoditas", "/komoditas"],
          ])}
        </Collapse>

        {/* ========== ANGKUTAN MUSIMAN ========== */}
        <ListItemButton
          onClick={() => setOpenMusiman(!openMusiman)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <CalendarMonth fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Angkutan HBKN"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openMusiman ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openMusiman}>
          {renderSubmenu([
            ["Angkutan Nataru", "/angkutanNataru"],
            ["Angkutan Lebaran", "/angkutanLebaran"],
          ])}
        </Collapse>

        {/* ========== PENINDAKAN DALOPS ========== */}
        <ListItemButton
          onClick={() => setOpenDalops(!openDalops)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <Gavel fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Penindakan Dalops"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openDalops ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openDalops}>
          {renderSubmenu([["Data Penindakan", "/penindakanDalops"]])}
        </Collapse>

        {/* ========== DATA PARKIR ========== */}
        <ListItemButton
          onClick={() => setOpenParkir(!openParkir)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <LocalParking fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Data Perparkiran"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openParkir ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openParkir}>
          {renderSubmenu([["Data Parkir", "/dataParkir"]])}
        </Collapse>
        
        {/* ========== DATA PENGUJIAN ========== */}
        <ListItemButton
          onClick={() => setOpenPengujian(!openPengujian)}
          sx={{ py: 0.8, "&:hover": { bgcolor: "#1F3F63" } }}
        >
          <ListItemIcon sx={{ color: "white", minWidth: 35 }}>
            <FactCheck fontSize="small" />
          </ListItemIcon>

          {open && (
            <ListItemText
              primary="Data Pengujian"
              primaryTypographyProps={{ fontSize: 12, fontWeight: 500 }}
            />
          )}

          {open && (openPengujian ? <ExpandLess /> : <ExpandMore />)}
        </ListItemButton>

        <Collapse in={openPengujian}>
          {renderSubmenu([["Data Kelulusan KIR", "/pengujian"]])}
        </Collapse>
      </List>
    </Drawer>
  );
}
